import React, { useEffect, useState } from "react";
import CardsTable from "./components/CardsTable";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";
import Edit from "./modals/Edit";

function Cards(props) {
  const token = useSelector((state) => state.auth.token);
  const [cards, setCards] = useState([]);
  const [chooseCardId, setChooseCardId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteCardsIds, setDeleteCardsIds] = useState([]);

  const [showEdit, setShowEdit] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    name: "",
    number: "",
    status: "",
  
  });

  const onCards = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}sync/data`)
      .then(({ data}) => {
        setIsLoading(false);
        setCards(data);
        setIsError(false);
        
      })
      .catch(() => {
        setIsLoading(false);
        setCards([]);
        setIsError(true);
      });
  };

  const onCardChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}sync/data/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onCards();
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const [device, setDevice] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}device`)
      .then(({ data: { content } }) => {
        const device = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDevice(device);
      });
  }, []);

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Sinxronizasiya ayarları</h1>
      </div>
      <Divider className="w-100" />
      <CardsTable
        cards={cards}
        isLoading={isLoading}
        isError={isError}
        setChooseCardId={setChooseCardId}
     
        setShowEdit={setShowEdit}
        setDeleteCardsIds={setDeleteCardsIds}
        deleteCardsIds={deleteCardsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
     
      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onCards={onCards}
          chooseCardId={chooseCardId}
          onCardChoose={onCardChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          device={device}
        />
      )}


    </div>
  );
}

export default Cards;
